import { SiteAddress } from 'api/addresssearch/schema';

const isSiteAddress = (result: unknown): result is SiteAddress => {
  return (result as SiteAddress)?.address_line_1 !== undefined;
};
export default isSiteAddress;
